import apiClient from "../Util/ApiClient";

export default class PermissionApi {

    static filter = (query = {}) => {
        return apiClient.get('/permissions', {
            params: query
        })
    };
}